import React from "react";
import flint from "../../assets/logo-alt-removebg.png";
import Contact from "../web_development/Contact";
import Banner from '../../assets/about-us-banner.png'

const FlintAboutUs = () => {
  return (
    <>
    <div className="flex flex-col-reverse sm:flex-row w-full items-center justify-end sm:px-10 py-12 sm:py-8  px-3">
      <div className="font-notosans w-full">
        <div className="flex flex-col-reverse lg:flex-row justify-between items-center lg:items-start">
            <div>
              <p className="text-4xl font-bold font-notosans text-center sm:text-left lg:mt-10">About Us</p>
              <p className="text-2xl font-bold font-notosans  text-slate-500  text-center sm:text-left mt-4">Delivering Dynamic Technology Solutions for Your Business Needs</p>
              <p className="text-lg font-notosans mt-8 lg:mt-12">
                Flint is a Technology Solutions Company offering foundational,
                sustenance, and digital transformation services across multiple
                technologies to global businesses. We provide a blend of industry
                domain and function-specific solutions and services on Multi-Cloud,
                Mobility, Analytics, Enterprise Technology, Platform and Application
                Management, Web Development and Cross-Platform Integration. Our offerings drive
                business effectiveness and efficiency while striving for innovation,
                flexibility, and integration with technology. Our ISO 9001 and ISO
                27001 certifications and appraisal at CMMI Maturity Level 3 - reflects
                our strong core values and business ethics. With our office in the
                India, we maintain the right balance of on-shore client engagement and
                off-shore delivery and cost efficiencies. Whatever be the IT challenge
                your organization is facing; we are here for you. We will help you
                leverage technology, optimize your strengths, and gain a competitive
                advantage without ever compromising on quality.
              </p>
            </div>
            <img
              src={Banner}
              alt="banner"
              className="h-[auto] w-[74vw] scale-110 sm:scale-100 sm:w-[auto] sm:h-[250px] md:h-[300px] lg:h-[380px] xl:h-[420px] z-[1]"
            />
          </div>
      </div>
      {/* <div className="w-full sm:w-1/4">
        <img className="w-full" src={flint} />
      </div> */}
    </div>
    <Contact />
    </>
  );
};

export default FlintAboutUs;
